module.exports = __webpack_public_path__ + "static/media/22904910_1638431882898663_6347954105983718813_o.2863b5a4.jpg";